module.exports = __webpack_public_path__ + "static/media/rede-protecao-2.c764f9d0.jpeg";